import React from 'react';
import { toaster, Notification } from 'rsuite';

const DEFAULT_DURATION = 5000;

const Alert = {
    success (message, duration = DEFAULT_DURATION) {
        toaster.push(
            <Notification type="success" header="Éxito" duration={duration}>
                {message}
            </Notification>,
            { placement: 'topEnd' }
        );
    },
    error (message, duration = DEFAULT_DURATION) {
        toaster.push(
            <Notification type="error" header="Error" duration={duration}>
                {message}
            </Notification>,
            { placement: 'topEnd' }
        );
    },
    warning (message, duration = DEFAULT_DURATION) {
        toaster.push(
            <Notification type="warning" header="Advertencia" duration={duration}>
                {message}
            </Notification>,
            { placement: 'topEnd' }
        );
    },
    info (message, duration = DEFAULT_DURATION) {
        toaster.push(
            <Notification type="info" header="Información" duration={duration}>
                {message}
            </Notification>,
            { placement: 'topEnd' }
        );
    }
};

export default Alert;
